import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import orderBy from 'lodash/orderBy';

import * as Store from 'store';

import * as Actions from '../actions';
import * as Types from '../types';

interface IChildren {
  items: Types.IEntity.Specialization[];
  isFetched: boolean;
  isLoaded: boolean;
}

interface IProps {
  documentId: number;
  onSuccess?: ({ specialization }: { specialization: Types.IEntity.Specialization[] }) => void;
  onError?: () => void;
  onFinally?: () => void;
}

let cancelSource = axios.CancelToken.source();

const useSpecialization = ({ documentId, onSuccess = () => {}, onError = () => {}, onFinally = () => {} }: IProps): IChildren => {
  const dispatch = useDispatch();

  // const documentId = useSelector<Store.Types.IState, number>(state => state.process.process.documentId);
  const items = useSelector<Store.Types.IState, Types.IEntity.Specialization[]>(state => orderBy(state.process.specialization.items, ['position'], ['asc']));
  const isFetched = useSelector<Store.Types.IState, boolean>(state => state.process.specialization.isFetched);
  const isLoaded = useSelector<Store.Types.IState, boolean>(state => state.process.specialization.isLoaded);

  useEffect(() => () => cancelSource.cancel('canceled'), []);

  useEffect(() => {
    cancelSource = axios.CancelToken.source();
    dispatch(Actions.Specialization.request({
      documentId,
      cancelSource,
      callback: {
        onSuccess,
        onError,
        onFinally
      }
    }));
  }, []);

  return { items, isFetched, isLoaded };
};

export default useSpecialization;